<template>
  <div class="select-card" :class="{ isSingle: isSingle }">
    <h1 class="name">{{ courseInfo.productName }}</h1>
    <div class="courseSelect" v-show="!isSingle" v-for="(item, n) in productSpecJson" :key="n">
      <h3 class="subheading" v-text="item.specName"></h3>
      <div class="courseSelectTabs">
        <p
          class="tabItem ellipsis"
          v-for="(list, index) in item.options"
          :key="index"
          @click="chooseSkuInfo(list.name, n, $event, index)"
          :class="{ noneActive: !list.isShow, tabSelected: subIndex[n] == index }"
        >
          <span v-text="list.name"></span>
          <img v-if="subIndex[n] == index" :src="checkIcon" alt="checkIcon" />
        </p>
      </div>
    </div>
    <img class="single-icon" :src="checkIcon" alt="checkIcon" />
  </div>
</template>

<script>
import checkIcon from '@/assets/img/components/courseDetail/checkIcon.png';

export default {
  components: {},
  props: {
    courseInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      checkIcon,
      productSpecJson: [], // 展示在页面的sku规格
      selectArr: [], // 选中的值
      shopItemInfo: {}, // 存放要和选中的值进行匹配的数据
      subIndex: [], // 是否选中
      selectSku: {}, // 选中的sku信息
      someOne: null, // 可用的一条sku，用于展示默认选中的sku
      isSingle: false, // 是否为单品
    };
  },
  computed: {},
  mounted() {
    this.modifySkuRespVOList();
  },
  methods: {
    // 选中sku属性
    chooseSkuInfo(item, n, event, index) {
      if (this.selectArr[n] !== item) {
        [this.selectArr[n], this.subIndex[n]] = [item, index];
      } else {
        this.selectSku = {};
        [this.selectArr[n], this.subIndex[n]] = ['', '-1'];
      }
      // this.findItem(item);
      if (n === 0) {
        const skuSpecJson = JSON.parse(this.selectSku.skuSpecJson);
        if (skuSpecJson.length > 1) {
          const arr = [item, skuSpecJson[1].value];
          const findRes = this.courseInfo.packageProductSkuWebRespList.find((ele) => {
            const defautName = [];
            if ((ele.isSetStock === 1 && ele.availableStock > 0) || ele.isSetStock === 0) {
              JSON.parse(ele.skuSpecJson).forEach((item) => {
                defautName.push(item.value);
              });
            }
            return defautName.toString() === arr.toString();
          });
          if (!findRes) {
            this.findItem(item, n, index);
          }
        }
      }

      this.checkItem();
    },
    findItem(item) {
      let res = null;
      try {
        this.courseInfo.packageProductSkuWebRespList.forEach((ele) => {
          const specJson = JSON.parse(ele.skuSpecJson);
          specJson.forEach((list) => {
            if (list.value === item && ((ele.isSetStock === 1 && ele.availableStock > 0) || ele.isSetStock === 0)) {
              res = ele;
              throw Error();
            }
          });
        });
      } catch (error) {
        //
      }
      this.setDefault([res]);
    },
    checkItem() {
      const self = this;
      const result = this.selectArr; // 定义数组储存被选中的值
      this.productSpecJson.forEach((element, i) => {
        const last = result[i];
        element.options.forEach((k) => {
          result[i] = k.name;
          // k.isShow = this.someOne ? this.isMay(result) : false; // isShow来判断是否可以选择
          Object.assign(k, { isShow: this.someOne ? this.isMay(result) : false });
          if (i === 0) {
            const filterRes = this.courseInfo?.packageProductSkuWebRespList.filter((item) => !(item.isSetStock === 1 && item.availableStock === 0));
            const flag = filterRes.find((item) => JSON.parse(item.skuSpecJson).find((child) => child.value === k.name));
            Object.assign(k, { isShow: !!flag });
          }
          // if (i === 0 && this.productSpecJson.length > 1 && this.courseInfo?.packageProductSkuWebRespList?.length > 1) {
          //   Object.assign(k, { isShow: true });
          // }
        });
        result[i] = last; // 还原，目的是记录点下去那个值
      });
      if (this.shopItemInfo[result]) {
        this.selectSku = this.shopItemInfo[result];
        this.sendParentSkuId(this.selectSku);
      }
      self.$forceUpdate(); // 重绘
    },
    // 能否被选中
    isMay(result) {
      // eslint-disable-next-line no-restricted-syntax
      for (const k in result) {
        if (result[k] === '') {
          return true;
        }
      }
      // 校验list中是否有此条sku
      if (result && !this.shopItemInfo[result]) {
        return false;
      }
      // 校验sku库存
      return !(
        this.shopItemInfo[result].isSetStock === 1 && this.shopItemInfo[result].availableStock === 0
      );
    },
    // 修改数据结构,将选中的值作为key，以方便和选中之后的值进行匹配
    modifySkuRespVOList() {
      const { packageProductSkuWebRespList, productSpecJson } = this.courseInfo;
      if (!productSpecJson && !packageProductSkuWebRespList) return;
      // if (!productSpecJson) {
      //   // 无sku
      //   this.$store.dispatch('saveProductSku', packageProductSkuWebRespList[0]);
      //   return;
      // }
      packageProductSkuWebRespList.forEach((item) => {
        this.isSingle = item.isDefault === 1;
        this.shopItemInfo[String(JSON.parse(item.skuSpecJson).map((child) => child.value))] = item;
      });
      JSON.parse(productSpecJson).forEach((item) => {
        Object.assign(item, { options: item.options.map((element) => ({ name: element })) });
        this.productSpecJson.push(item);
      });
      this.setDefault(packageProductSkuWebRespList);
      this.checkItem();
    },
    // 默认一个可用的sku
    setDefault(packageProductSkuWebRespList) {
      const defautIdx = [];
      const defautName = [];
      this.someOne = packageProductSkuWebRespList.find(
        (item) => (item.isSetStock === 1 && item.availableStock > 0) || item.isSetStock === 0,
      );
      if (!this.someOne) return;
      this.productSpecJson.forEach((item) => {
        item.options.forEach((list, i) => {
          JSON.parse(this.someOne.skuSpecJson).forEach((child) => {
            if (list.name === child.value) {
              defautName.push(list.name);
              defautIdx.push(i);
            }
          });
        });
      });
      this.subIndex = defautIdx;
      this.selectArr = defautName;
    },
    // 将选中的sku保存到vuex 中
    sendParentSkuId(sku) {
      if (!sku.skuId) return;
      const course = JSON.parse(JSON.stringify(this.courseInfo));
      course.selectSkuInfo = sku;
      this.$emit('skuInfo', course);
    },
    // 进入详情
    enterDetails(courseInfo) {
      // 判断是否App
      if (this.$root.$data.isApp) {
        this.$sendToApp('goCourseDetail', Number(courseInfo.productId), false);
        return;
      }
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: courseInfo.productId,
        },
      });
    },
  },
  filters: {
    changeDeadLineTime(value) {
      return value.split(' ')[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.select-card {
  padding: 40px 40px;
  .single-icon {
    display: none;
  }
}
.isSingle.select-card {
  position: relative;
  width: 678px;
  margin: 20px auto;
  padding: 29px 30px;
  background: #fff5ed;
  border: 2px solid #ff6c02;
  border-radius: 4px;
  // margin-bottom: 20px solid #f9f9f9;

  .single-icon {
    position: absolute;
    right: 0;
    bottom: 0;
    display: block;
    width: 30px;
    height: 30px;
  }
  .name{
    color: #FF6C02;
  }
}
.name {
  padding-bottom: 5px;
  color: #333;
  font-weight: 600;
  font-size: 32px;
  line-height: 44px;
}
.courseSelect {
  display: flex;
  width: 100%;
  // min-height: 130px;
  // margin: 22px 0;
  padding: 5px 0 0 0;
  background: #fff;
  // border-radius: 14px;
  // box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.03);

  //   &:first-child {
  //     padding-top: 26px;
  //   }
  //   &:last-child {
  //     padding-bottom: 26px;
  //   }

  .subheading {
    flex-shrink: 0;
    width: 115px;
    // margin-right: 19px;
    padding-top: 28px;
    color: #333;
    font-weight: 600;
    font-size: 28px;
  }
  .courseSelectTabs {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    // margin-left: 4px;

    p {
      position: relative;
      box-sizing: border-box;
      width: 164px;
      margin: 10px;
      padding: 12px;
      overflow: hidden;
      color: #787878;
      font-size: 22px;
      line-height: 30px;
      text-align: center;
      background: #fff;
      border: 2px solid #e8e8e8;
      border-radius: 4px;

      img {
        position: absolute;
        right: 0;
        bottom: 0;
        display: none;
        width: 30px;
        height: auto;
      }
    }

     p:nth-child(3n) {
      margin-right: 0;
    }

    .tabSelected {
      box-sizing: border-box;
      color: #ff6c02;
      background: #fff5ed;
      border: 2px solid #ff6c02;
      border-radius: 4px;
      pointer-events: none;
      img {
        display: block;
      }
    }

    .noneActive {
      color: #cfcfcf;
      background: #f5f5f5;
      border: 2px solid #f5f5f5;
      border-radius: 4px;
      pointer-events: none;
      img {
        display: none;
      }
    }
  }
}
</style>
